import{z}from"zod";import{emailValidator}from"../../../lib/validator/email";export var ResetPasswordFormSchema=z.object({email:emailValidator});